//
// Helpers for the emission coverage page / facility dialog.
// Coverage rows come from /api/emissioncoverage:
//   { facilityId, organizationCode, facilityName, type, sensors, emissions,
//     activeEmission, withoutEmission, foreignEmission, firstDay, lastDay }
//

export const EMISSION_TYPES = [0, 1, 2, 3] // power, gas, water, heat

// the standard template of a medium — same rule as
// OrganizationManagement.defaultSupplyContractForType: the contract flagged
// isDefault for that type, otherwise the ONLY contract of that type
export function defaultContractForType (contracts, type) {
  const matching = (contracts || []).filter(c => c.scope === type)
  const flagged = matching.filter(c => c.isDefault)
  if (flagged.length === 1) return flagged[0]
  return matching.length === 1 ? matching[0] : null
}

export function unassignedCount (row) {
  return (row.withoutEmission || 0) + (row.foreignEmission || 0)
}

export function isGap (row) {
  return !row.activeEmission || unassignedCount(row) > 0
}

// what a fix will do for this row: 'stamp' (active emission exists, only
// stamping), 'create' (template needed) — the page shows it per row
export function fixAction (row) {
  return row.activeEmission ? 'stamp' : 'create'
}

// rows that can be fixed with the chosen templates (type -> contract id)
export function fixableRows (rows, chosenContracts) {
  return rows.filter(r => r.activeEmission || !!chosenContracts[r.type])
}

// summary for the page header
export function coverageSummary (rows) {
  const facilities = new Set(rows.map(r => r.facilityId))
  return {
    facilities: facilities.size,
    combinations: rows.length,
    withoutActive: rows.filter(r => !r.activeEmission).length,
    unassigned: rows.reduce((sum, r) => sum + unassignedCount(r), 0)
  }
}
